var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EChart',_vm._b({attrs:{"theme":"ovilia-green","autoresize":""},on:{"click":(params) => _vm.$emit('click', params)}},'EChart',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }